<div class="calendar-container">
  <h4 class="text-center mb-4">
    <i class="bi bi-calendar3 me-2"></i>Holiday Calendar, {{ currentYear }}
  </h4>

  <div class="text-center mb-3">
    <button class="btn btn-sm btn-outline-primary me-2" (click)="onYearChange(-1)">❮</button>
    {{ currentYear }}
    <button class="btn btn-sm btn-outline-primary ms-2" (click)="onYearChange(1)">❯</button>
  </div>

  <div class="row">
    <div class="col-lg-4 col-md-6" *ngFor="let month of monthsWithDays; let i = index">
      <div class="card">
        <div class="calendar-component-header">
          <h5 class="mb-0 fw-bold">{{ monthNames[i] }} <small>{{ currentYear }}</small></h5>
        </div>
        <div class="week-component-header">
          <div class="flex-fill">Mon</div>
          <div class="flex-fill">Tue</div>
          <div class="flex-fill">Wed</div>
          <div class="flex-fill">Thu</div>
          <div class="flex-fill">Fri</div>
          <div class="flex-fill">Sat</div>
          <div class="flex-fill">Sun</div>
        </div>
        <div class="card-body" style="min-height: 310px;">


          <div class="calendar-grid d-flex flex-wrap">
            <div *ngFor="let day of month" 
         
            class="calendar-day text-center" [ngClass]="{ 'is-holiday': day?.holiday }"
              [attr.title]="day?.holiday?.name" [style.--event-color]="day?.holiday?.sEventColor"
              [attr.data-bs-toggle]="day?.holiday ? 'tooltip' : null"
             
              (click)="openHolidayModal(day?.holiday)"  [ngStyle]="{
      'background-color':
        day?.isSunday
            ? '#ff4d4f'
            : '',
      'color':
       day?.isSunday
          ? '#ffffff'
          : ''
    }">
              <span *ngIf="day"     >{{ day.day }}</span>
            </div>
          </div>
          <div class="modal fade" id="holidayModal" tabindex="-1" aria-labelledby="holidayModalLabel"
            aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header" *ngIf="selectedHoliday">
                  <h5 class="modal-title" id="holidayModalLabel">{{ selectedHoliday.name }}</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" *ngIf="selectedHoliday">
                  {{ selectedHoliday.sEventDescription }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>